import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  color: string
}

export default createStyles((theme, { color }: StylesParams) => {
  return {
    root: {
      position: 'relative',
      backgroundColor: color,
      borderRadius: rem(20),
      overflow: 'hidden',
    },
    circle: {
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 1,
      opacity: 0.5,
      transform: `translate(50%, -50%)`,
    },
    wrapper: {
      position: 'relative',
      zIndex: 2,
      padding: `${rem(16)} ${rem(24)}`,
      display: 'flex',
      flexDirection: 'column',
      gap: rem(8),
      height: '100%',
      [theme.fn.largerThan('sm')]: {
        justifyContent: 'space-between',
        padding: rem(24),
      },
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(8),
    },
    header: {
      display: 'flex',
      gap: rem(16),
      [theme.fn.smallerThan('sm')]: {
        alignItems: 'center',
      },
      [theme.fn.largerThan('sm')]: {
        gap: rem(24),
        flexDirection: 'column',
      },
    },
    actions: {
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
    imgWrapper: {
      width: rem(48),
      borderRadius: '50%',
      overflow: 'hidden',
      background: '#fff',
      flexShrink: 0,
      [theme.fn.largerThan('sm')]: {
        width: rem(80),
      },
    },
    reviewer: {},
  }
})
